import { apiClient } from "api/trpc/trpc-client"
import OrgGuardStore from "features/main/main-router/org-guard/OrgGuardStore"
import WebSocketEventClientListUpdate from "../websockets/models/WebSocketEventClientListUpdate"
import { AdvisorClientDto } from '@gap/backend/app-services/advisor/client/models/AdvisorClientDto'
import Loader from "reusable/mobx-helpers/Loader"
import { makeAutoObservable } from "mobx"

interface ClientsCacheStoreProps {
   orgGuardStore: OrgGuardStore
}

export default class ClientsCacheStore {
   sp
   clientsLoader = new Loader(false)
   private _clients: AdvisorClientDto.idWithName[]

   constructor(sp: ClientsCacheStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get clients(): AdvisorClientDto.idWithName[] {
      if (!this._clients) {
         this._clients = []
      }
      return this._clients
   }

   handleClientsEvent = (clientsUpdateEvent: WebSocketEventClientListUpdate) => {
      switch (clientsUpdateEvent.action) {
         case 'add':
         case 'update':
            return this.onClientUpdate(clientsUpdateEvent)
         case 'sync':
            return this.fetch()
      }
   }

   onClientUpdate = (clientUpdateEvent: WebSocketEventClientListUpdate) => {
      switch (clientUpdateEvent.action) {
         case 'add':
            this._clients.push(clientUpdateEvent.client)
            break
         case 'update':
            this._clients = this._clients.map(client => {
               if (client.id === clientUpdateEvent.client.id) {
                  return clientUpdateEvent.client
               }
               return client
            })
            break
      }
   }

   fetch = async () => {
      await this.clientsLoader.executeLoading(async () => {
         if (this.sp.orgGuardStore.userOrg.orgType === 'advisor' && !this.sp.orgGuardStore.userOrg.isDeactivated) {
            this._clients = await apiClient.advisor.getMinimalClients.query({ status: ['client', 'prospect'] })
         }
      })
   }
}
